import getSymbolFromCurrency from 'currency-symbol-map';
import { numberFormat } from '../../utils/validations-functions/number-format';

/**
 * Formats an account balance as "<symbol><amount>" using the balance currency
 * (falling back to the base currency). Returns '' when there is no balance.
 */
export const formatBalance = (
    balance: number | string | null | undefined,
    balanceCurrency?: string | null,
    baseCurrency?: string | null,
): string => {
    if (balance === null || balance === undefined || balance === '') return '';
    const currencyCode = balanceCurrency || baseCurrency || '';
    const symbol = (currencyCode && getSymbolFromCurrency(currencyCode)) || '';
    const formattedBalance = numberFormat(Number(balance), currencyCode, true, true);
    return `${symbol}${formattedBalance}`;
};
